// server 
export const dominio = process.env.VUE_APP_DOMINIO;

export const server = process.env.VUE_APP_SERVER;
